import { render, staticRenderFns } from "./helpPlayer.vue?vue&type=template&id=68860262&scoped=true"
import script from "./helpPlayer.vue?vue&type=script&lang=js"
export * from "./helpPlayer.vue?vue&type=script&lang=js"
import style0 from "./helpPlayer.vue?vue&type=style&index=0&id=68860262&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68860262",
  null
  
)

export default component.exports